import React from 'react';
import { noop } from './utils';
export var contextObject = {
    linkToken: null,
    version: null,
    uniqueUserId: null,
    fireUnifiedEvent: null,
    fireProperEventType: null,
    fireTrackEvent: null,
    isDemoMode: false,
    getLocalizedString: null,
    exit: noop,
};
var Ctx = React.createContext(contextObject);
/**
 * @deprecated Avoid using `useOpts()` for accessing duplicated state like `workspaceName`.
 *
 * NOTE: Historically, we managed state via React context (`useOpts`), but we’ve migrated to Redux.
 * Going forward, prefer pulling from Redux directly (e.g., using `useAppSelector`).
 * This helps consolidate state management and simplifies future refactors
 * to fully eliminate `useOpts`-based state access.
 */
export var useOpts = function () { return React.useContext(Ctx); };
export default Ctx;
